import { RangeKey } from './BirthdayService';

interface Props {
    rangeKey: RangeKey;
    counts: Record<RangeKey, number>;
    onChange: (v: RangeKey) => void;
}

const TABS: { key: RangeKey; label: string }[] = [
    { key: 7, label: 'This week' },
    { key: 30, label: 'This month' },
    { key: 90, label: 'Next 3 months' },
    { key: 365, label: 'See all' },
];

const BirthdayTabs = ({ rangeKey, counts, onChange }: Props) => {
    return (
        <div className="d-flex flex-wrap gap-2 bd-tabs mb-3">
            {TABS.map((tab) => {
                const isActive = tab.key === rangeKey;
                return (
                    <button
                        key={tab.key}
                        type="button"
                        className={`bd-tab ${isActive ? 'bd-tab--active' : ''}`}
                        aria-pressed={isActive}
                        onClick={() => onChange(tab.key)}>
                        <span className="bd-tab-label">{tab.label}</span>
                        <span className="bd-tab-count">{counts[tab.key] ?? 0}</span>
                    </button>
                );
            })}
        </div>
    );
};

export default BirthdayTabs;
